// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { Paper, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconTrendingUp, IconTrendingDown } from '@tabler/icons-react';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: React.ReactNode;
  color?: string;
  trend?: { value: number; label: string };
}

export function StatCard({
  title,
  value,
  subtitle,
  icon,
  color = 'blue',
  trend,
}: StatCardProps) {
  const trendColor = trend
    ? trend.value >= 0
      ? 'teal'
      : 'red'
    : undefined;

  return (
    <Paper withBorder p="md" radius="md">
      <Group justify="space-between" ta="left">
        <Stack gap={4} style={{ flex: 1 }}>
          <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
            {title}
          </Text>
          <Text fw={700} fz={28} lh={1}>
            {value}
          </Text>
          {subtitle && (
            <Text size="xs" c="dimmed">
              {subtitle}
            </Text>
          )}
          {trend && (
            <Group gap={4} mt={4}>
              {trend.value >= 0 ? (
                <IconTrendingUp size={16} color={`var(--mantine-color-${trendColor}-6)`} />
              ) : (
                <IconTrendingDown size={16} color={`var(--mantine-color-${trendColor}-6)`} />
              )}
              <Text size="xs" c={trendColor} fw={500}>
                {trend.value >= 0 ? '+' : ''}
                {trend.value}%
              </Text>
              <Text size="xs" c="dimmed">
                {trend.label}
              </Text>
            </Group>
          )}
        </Stack>
        <ThemeIcon
          color={color}
          variant="light"
          size={48}
          radius="md"
        >
          {icon}
        </ThemeIcon>
      </Group>
    </Paper>
  );
}
